module.exports = __webpack_public_path__ + "img/d.d4311823.jpg";